import { CalibrationRodReadDto } from '../_generated/api/tagged-hardware'
import ApiLifeCycleModel from './ApiLifeCycleModel'
import TraceabilityTag from './TraceabilityTag'

export default class CalibrationRod extends ApiLifeCycleModel<CalibrationRodReadDto> {
    get id() {
        return this.data.id ?? ''
    }

    get serialNo() {
        return this.data.serialNo ?? ''
    }

    get material() {
        return this.data.material ?? undefined
    }

    get apxTotalLength() {
        return this.data.apxTotalLengthMm
    }

    get currentTag() {
        return TraceabilityTag.nullable(this.data.currentTag)
    }

    get previousTags() {
        return this.data.previousTags?.map((t) => new TraceabilityTag(t)) ?? []
    }
}
